module.exports = __webpack_public_path__ + "static/media/Decisions_Step5_Image18.172628be.jpg";